/**
 * Copied from https://viagogo.visualstudio.com/Packages/_git/Viagogo.Npm.Core?path=/src/themes/shared/colors.ts
 * because the package doesn't export these values.
 *
 * This should **NOT** be used outside of the `themes/` directory.
 */
export const Colors = {
  // viagogo
  green075: '#71a230',
  green100: '#6fb229',
  green150: '#8ac53b',
  green200: '#8cc63f',
  green300: '#a3d165',
  green400: '#badd8c',
  green450: '#cee7ae',
  green500: '#d1e8b2',
  green600: '#e8f4d9',
  green700: '#f3f9eb',
  gray100: '#37383a',
  gray200: '#5f6062',
  gray250: '#87909a',
  gray300: '#7f8081',
  gray400: '#9fa0a1',
  gray450: '#bfc0c0',
  gray500: '#bfc0c0',
  gray600: '#dfdfe0',
  gray700: '#efefef',
  gray800: '#f2f2f2',
  gray900: '#f9f9f9',
  gray1000: '#f6f8f9',
  blue075: '#0094dc',
  blue075Light: '#0075c4',
  blue100: '#1eb0ee',
  blue200: '#22afee',
  blue300: '#47BEF0', // this is the categories sports color
  blue500: '#b0e3f8',
  blue600: '#e1f3fd',
  blue700: '#e1f3fd',

  magenta300: '#f4538d',
  yellow100: '#ffb900',
  red100: '#B71C1C',
  red200: '#D32F2F',
  red300: '#da4f49',
  red400: 'e53935',
  red500: '#EF5350',
  red600: '#E57373',
  black: '#000',
  white: '#fff',
  darkBlue250: '#0f5b99',
  darkBlue300: '#0c709a',
  darkBlue700: '#0f5b99',
  dark050: '#202327',
  dark060: '#212428',

  // Stubhub
  indigo025: '#15032E',
  indigo050: '#1E093A',
  indigo060: '#29134C',
  indigo070: '#2D0F54',
  indigo075: '#260354',
  indigo100: '#3F1D75',
  indigo150: '#4611a1',
  indigo200: '#643CA2',
  indigo250: '#671de7',
  indigo300: '#55279E',
  indigo500: '#825ABF',
  indigo550: '#B180FF',
  indigo600: '#D4B9FF',
  indigo700: '#F1EBFA',
  indigo800: '#efe8fd',

  // TicketUtil
  tuBlue025: '#2A3944',
  tuBlue100: '#0084EA',
  tuBlue200: '#339CEE',
  tuBlue300: '#66B5F2',
  tuBlue400: '#99CEF6',
  tuBlue500: '#CCE6FB',
  tuBlue600: '#E6F3FD',

  fuchsia075: '#AF346B',
  fuchsia100: '#DB2C7B',
  fuchsia200: '#ED2E80',
  fuchsia500: '#F56AA8',
  fuchsia600: '#FBBBD6',
  fuchsia700: '#FBEAF1',

  aqua075: '#0D8282',
  aqua100: '#29B2B2',
  aqua200: '#49D4D4',
  aqua500: '#72C8C9',
  aqua600: '#ABDDDE',
  aqua700: '#DAFAFC',

  neutral000: '#000000',
  neutral025: '#121212',
  neutral050: '#191C1F',
  neutral075: '#2F343B',
  neutral100: '#677383',
  neutral150: '#798595',
  neutral200: '#87909A',
  neutral300: '#B1BAC2',
  neutral400: '#CFD4D9',
  neutral500: '#E6E9EB',
  neutral600: '#F6F8F9',
  neutral700: '#FBFCFC',
  neutral1000: '#FFFFFF',

  negative075: '#9F2B18',
  negative100: '#D91A1A',
  negative200: '#FF3939',
  negative400: '#F5c9c2',
  negative500: '#FCEFED',

  success075: '#198620',
  success100: '#00A645',
  success500: '#E5FFF0',
  warning075: '#996E00',
  warning100: '#F2B824',
  warning500: '#FEF7E7',

  info075: '#0F5894',
  info100: '#1475C4',
  info200: '#218FE8',
  info500: '#DAECFB',
  info700: '#E0ECFF',

  darkInfo: '#1A2A44',

  // Brand-specific color that don't have regular color naming
  brandAxs: '#0055A0',
  brandVivid: '#CE3197',
  brandSeatgeek: '#FF5B49',
  brandTickPick: '#3399FF',
  brandTicketmaster: '#026BDE',
  brandFanXchange: '#006099',
  brandTicketEvolution: '#9A362C',
  brandTicketNetwork: '#3A519D',
  brandTelecharge: '#000B6F',
  brandTicketon: '#202867',
  brandSeetickets: '#009C9B',
  brandMgmResorts: '#16057D',
  brandSmithCenterImport: '#63948E',
  brandComputicket: '#B50D90',
  brandLyte: '#F7F7F7',
  brandGoTickets: '#3899F8',
  brandB2BSales: '#ffffff',
  brandGametime: '#19CE85',

  textSeatgeek: '#181818',
  textFanXchange: '#15F2D3',
  textEventbrite: '#FF5B49',
  textTicketon: '#FECA27',
  textEtix: '#00579B',
  textMgmResorts: '#FFF9BE',

  backgroundStubhubSeatmap: '#C2B5E0',

  seatCardBackgroundColor: '#1A2426',
} as const;

export const ColorsV2 = {
  indigo003: '#15032E',
  indigo005: '#1E093A',
  indigo006: '#29134C',
  indigo007: '#2D0F54',
  indigo008: '#260354',
  indigo010: '#3F1D75',
  indigo020: '#643CA2',
  indigo030: '#55279E',
  indigo050: '#825ABF',
  indigo060: '#D4B9FF',
  indigo070: '#F1EBFA',

  neutral000: '#000000',
  neutral003: '#121212',
  neutral005: '#191C1F',
  neutral008: '#2F343B',
  neutral010: '#677383',
  neutral020: '#87909A',
  neutral030: '#B1BAC2',
  neutral040: '#CFD4D9',
  neutral050: '#E6E9EB',
  neutral060: '#F6F8F9',
  neutral070: '#FBFCFC',
  neutral100: '#FFFFFF',

  fuchsia008: '#AF346B',
  fuchsia010: '#DB2C7B',
  fuchsia020: '#ED2E80',
  fuchsia050: '#F56AAb',
  fuchsia060: '#FBBBD6',
  fuchsia070: '#FBEAF1',

  error008: '#9F2B18',
  error010: '#D91A1A',
  error020: '#FF3939',
  error050: '#FCEFED',

  turquoise080: '#0D8282',
  turquoise010: '#29B2B2',
  turquoise020: '#49D4D4',
  turquoise040: '#72C8C9',
  turquoise050: '#ABDDDE',
  turquoise070: '#DAFAFC',

  information004: '#0F5894',
  information010: '#1475C4',
  information020: '#218FE8',
  information050: '#DAECFB',

  success008: '#198620',
  success010: '#00A645',
  success050: '#E5FFF0',

  warning008: '#996E00',
  warning010: '#F2B824',
  warning050: '#FEF7E7',

  // Brand-specific color that don't have regular color naming
  brandAxs: '#0055A0',
  brandVivid: '#CE3197',
  brandSeatgeek: '#FF5B49',
  brandTickPick: '#3399FF',
  brandTicketmaster: '#026BDE',
  brandFanXchange: '#006099',
  brandTicketEvolution: '#9A362C',
  brandTicketNetwork: '#3A519D',
  brandTelecharge: '#000B6F',
  brandTicketon: '#202867',
  brandSeetickets: '#009C9B',
  brandMgmResorts: '#16057D',
  brandSmithCenterImport: '#63948E',
  brandComputicket: '#B50D90',
  brandLyte: '#F7F7F7',
  brandGoTickets: '#3899F8',
  brandB2BSales: '#ffffff',
  brandGametime: '#19CE85',

  textSeatgeek: '#181818',
  textFanXchange: '#15F2D3',
  textEventbrite: '#FF5B49',
  textTicketon: '#FECA27',
  textEtix: '#00579B',
  textMgmResorts: '#FFF9BE',

  backgroundStubhubSeatmap: '#C2B5E0',

  seatCardBackgroundColor: '#1A2426',
} as const;

export const colorDefaults = {
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  activeButtonText: Colors.indigo100,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  iconHover: Colors.indigo100,

  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  textPrimary: Colors.neutral100,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  textPrimaryHover: Colors.neutral200,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  textPrimaryActive: Colors.neutral300,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  textPrimaryLight: Colors.neutral200,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  textSecondary: Colors.fuchsia100,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  textStrong: Colors.neutral050,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  textStrongHover: Colors.neutral075,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  textStrongActive: Colors.neutral050,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  textBrand: Colors.indigo100,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  textBrandHover: Colors.indigo200,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  textBrandActive: Colors.indigo300,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  textBrandStrong: Colors.indigo050,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  textLinkPrimary: Colors.aqua075,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  textDisabled: Colors.neutral300,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  textSuccess: Colors.success100,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  textWarning: Colors.warning075,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  textError: Colors.negative100,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  textErrorHover: Colors.negative200,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  textInverted: Colors.white,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  textInvertedHover: Colors.neutral600,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  textInvertedCative: Colors.neutral500,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  textNegative: Colors.negative100,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  backgroundPrimary: Colors.white,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  backgroundPrimaryTransparent: Colors.white + '00',
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  backgroundPrimaryHover: Colors.neutral600,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  backgroundPrimaryActive: Colors.neutral700,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  backgroundSecondary: Colors.neutral600,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  backgroundSenondaryTransparent: Colors.neutral600 + '00',
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  backgroundBrand: Colors.indigo100,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  backgroundBrandInverted: Colors.indigo500,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  backgroundBrandHover: Colors.indigo200,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  backgroundBrandHoverNew: Colors.indigo700,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  backgroundBrandActive: Colors.indigo300,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  backgroundBrandHoverLight: Colors.indigo700,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  backgroundBrandSeatmap: Colors.backgroundStubhubSeatmap,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  backgroundSuccess: Colors.success500,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  backgroundDisabled: Colors.neutral500,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  backgroundWarning: Colors.warning500,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  backgroundError: Colors.negative500,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  backgroundHighlight: Colors.aqua700,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  backgroundHighlightHover: Colors.aqua600,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  backgroundTooltip: Colors.indigo025,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  backgroundTooltipOverlay: Colors.indigo025 + '60',
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  backgroundTooltipNeutral: Colors.neutral075,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  border: Colors.neutral400,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  borderNew: Colors.neutral400,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  borderHover: Colors.indigo100,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  borderHoverNew: Colors.indigo100,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  borderActive: Colors.indigo200,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  borderLight: Colors.neutral500,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  borderLightHover: Colors.neutral400,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  borderLightActive: Colors.indigo500,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  borderError: Colors.negative100,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  borderWarning: Colors.warning100,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  borderSuccess: Colors.success100,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  borderDisabled: Colors.neutral500,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  boxShadow: `${Colors.neutral075}25`,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  scrollbarThumb: Colors.neutral025,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  scrollbarThumbHover: Colors.neutral400,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  scrollbarTrack: Colors.neutral075,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  info: Colors.info700,

  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  marketplaceBackgroundStubhub: Colors.indigo100,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  marketplaceBackgroundAxs: Colors.brandAxs,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  marketplaceBackgroundVivid: Colors.brandVivid,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  marketplaceBackgroundSeatgeek: Colors.brandSeatgeek,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  marketplaceBackgroundTickPick: Colors.brandTickPick,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  marketplaceBackgroundTicketMaster: Colors.info100,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  marketplaceBackgroundOffline: Colors.neutral100,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  marketplaceBackgroundFanXchange: Colors.brandFanXchange,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  marketplaceBackgroundGametime: Colors.brandGametime,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  marketplaceBackgroundTicketEvolution: Colors.brandTicketEvolution,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  marketplaceBackgroundTicketNetwork: Colors.brandTicketNetwork,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  marketplaceBackgroundTicketmasterCa: Colors.info100,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  marketplaceBackgroundEventbrite: Colors.neutral700,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  marketplaceBackgroundLivenation: Colors.neutral700,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  marketplaceBackgroundBroadwayDotCom: Colors.negative100,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  marketplaceBackgroundTelecharge: Colors.brandTelecharge,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  marketplaceBackgroundTicketon: Colors.brandTicketon,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  marketplaceBackgroundSeetickets: Colors.brandSeetickets,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  marketplaceBackgroundEtix: Colors.neutral700,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  marketplaceBackgroundTixr: Colors.neutral000,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  marketplaceBackgroundFesticket: Colors.neutral700,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  marketplaceBackgroundInsomniac: Colors.fuchsia100,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  marketplaceBackgroundDiceImport: Colors.indigo100,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  marketplaceBackgroundMgmResorts: Colors.brandMgmResorts,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  marketplaceBackgroundTickeri: Colors.neutral700,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  marketplaceBackgroundSmithCenterImport: Colors.brandSmithCenterImport,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  marketplaceBackgroundStubwire: Colors.neutral000,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  marketplaceBackgroundComputicket: Colors.brandComputicket,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  marketplaceBackgroundAutomatiq: Colors.black,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  marketplaceBackgroundGoTickets: Colors.brandGoTickets,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  marketplaceBackgroundLyte: Colors.brandLyte,

  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  marketplaceTextSeatgeek: Colors.textSeatgeek,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  marketplaceTextFanXchange: Colors.textFanXchange,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  marketplaceTextEventbrite: Colors.textEventbrite,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  marketplaceTextLivenation: Colors.negative100,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  marketplaceTextTicketon: Colors.textTicketon,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  marketplaceTextEtix: Colors.textEtix,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  marketplaceTextFesticket: Colors.neutral000,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  marketplaceTextMgmResorts: Colors.textMgmResorts,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  marketplaceTextTickeri: Colors.fuchsia100,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  marketplaceTextStubwire: Colors.negative200,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  marketplaceTextAutomatiq: Colors.white,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  marketplaceTextDefault: Colors.neutral1000,

  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  seatCardBackgroundColor: Colors.aqua700,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  seatCardBorderColor: Colors.aqua075,

  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  compListingDisplayMyListingBadgeBackground: Colors.indigo700,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  compListingDisplayMyListingBadgeText: Colors.indigo500,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  compListingDisplayOutlierBadgeBackground: Colors.blue600,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  compListingDisplayOutlierBadgeText: Colors.blue075Light,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  compListingDisplayReferenceListingBadgeBackground: Colors.neutral600,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  compListingDisplayReferenceListingBadgeText: Colors.neutral050,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  autoPricingResultTypeHardConstraintBadgeBackground: Colors.negative500,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  autoPricingResultTypeHardConstraintText: Colors.red200,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  autoPricingResultTypeSoftConstraintBadgeBackground: Colors.warning500,
  /** @deprecated Use V2 tokens or create new semantic tokens as needed */
  autoPricingResultTypeSoftConstraintText: Colors.warning100,

  // New semantic tokens for v2
  // Surface tokens V2 (based on ReachPro Dark as default)
  surfacePrimary: ColorsV2.neutral003,
  surfaceTransparent: '#12121220', // 121212 @ 20% opacity
  surfaceSecondary: ColorsV2.neutral005,
  surfaceHighlight: ColorsV2.neutral008,
  surfaceSubtle: '#212428',
  surfaceBrand: ColorsV2.indigo060,
  surfaceBrandHover: '#B180FF',
  surfaceBrandSubtle: '#EFE8FD',
  surfaceSuccess: ColorsV2.success008,
  surfaceWarning: ColorsV2.warning008,
  surfaceError: ColorsV2.error008,
  surfaceInformation: ColorsV2.information004,
  surfaceInverted: ColorsV2.neutral100,

  // Text tokens V2 (based on ReachPro Dark as default)
  textPrimaryV2: ColorsV2.neutral100,
  textPrimaryHoverV2: ColorsV2.neutral070,
  textSecondaryV2: ColorsV2.neutral030,
  textSecondaryHoverV2: ColorsV2.neutral020,
  textDisabledV2: ColorsV2.neutral008,
  textBrandV2: ColorsV2.indigo060,
  textBrandHoverV2: '#B180FF',
  textSuccessV2: ColorsV2.success050,
  textWarningV2: ColorsV2.warning050,
  textErrorV2: ColorsV2.error050,
  textInformationV2: ColorsV2.information050,
  textLocationV2: ColorsV2.turquoise010,
  textInvertedV2: ColorsV2.neutral003,
  textInvertedHoverV2: ColorsV2.neutral005,

  // Icon tokens V2 (based on ReachPro Dark as default)
  iconBrand: ColorsV2.indigo060,
  iconPrimary: ColorsV2.neutral100,
  iconSecondary: ColorsV2.neutral010,
  iconDisabled: ColorsV2.neutral008,
  iconPrimaryInverted: ColorsV2.neutral003,
  iconSuccess: ColorsV2.success008,
  iconWarning: ColorsV2.warning008,
  iconError: ColorsV2.error008,
  iconInformation: ColorsV2.information004,

  // Border tokens (based on ReachPro Dark as default)
  borderBrand: ColorsV2.indigo060,
  borderPrimary: ColorsV2.neutral008,
  borderSecondary: ColorsV2.neutral010,
  borderDisabledV2: ColorsV2.neutral005,
  borderSuccessV2: ColorsV2.success008,
  borderWarningV2: ColorsV2.warning008,
  borderErrorV2: ColorsV2.error008,
  borderInformation: ColorsV2.information004,

  // Scrollbar tokens V2 (based on ReachPro Dark as default)
  scrollbarThumbV2: ColorsV2.neutral010,
  scrollbarThumbHoverV2: ColorsV2.neutral020,
  scrollbarTrackV2: ColorsV2.neutral008,

  // Marketplace tokens (brand colors)
  marketplaceAutomatiq: ColorsV2.neutral000,
  marketplaceAxs: '#0055A0',
  marketplaceGametime: '#19CE85',
  marketplaceGoTickets: '#3899F8',
  marketplaceSeatgeek: '#FF5B49',
  marketplaceStubhub: '#5E29BA',
  marketplaceTicketmaster: '#026BDE',
  marketplaceTickpick: '#3399FF',
  marketplaceVivid: '#CE3197',
  marketplaceSeetickets: '#009C9B',
  marketplaceTicketNetwork: '#3A519D',
  marketplaceOffline: ColorsV2.neutral008,
  marketplaceBroadwayDotCom: ColorsV2.error010,
  marketplaceComputicket: '#B50D90',
  marketplaceDice: ColorsV2.indigo020,
  marketplaceEtix: ColorsV2.neutral070,
  marketplaceEventbrite: ColorsV2.neutral070,
  marketplaceFanXchange: '#006099',
  marketplaceFesticket: ColorsV2.neutral070,
  marketplaceInsomniac: ColorsV2.fuchsia010,
  marketplaceLiveNation: ColorsV2.neutral070,
  marketplaceLyte: '#F7F7F7',
  marketplaceMgmResorts: '#16057D',
  marketplaceSmithCenter: '#63948E',
  marketplaceStubwire: ColorsV2.neutral000,
  marketplaceTelecharge: '#000B6F',
  marketplaceTicketon: '#202867',
  marketplaceTickeri: ColorsV2.neutral070,
  marketplaceTixr: ColorsV2.neutral000,
};
